import { FC } from 'react';

import { stopPropagation } from 'shared/utils/event/stopPropagation';

import { PublicationDateContainer } from '../internal/components/PublicationDate';
import { VASListContainer } from '../internal/components/VASList';

import styles from './VASBlock.css';

type VASBlockProps = {
  isAgentUser: boolean;
  isShortListing: boolean;
};

export const VASBlock: FC<VASBlockProps> = props => {
  const { isAgentUser, isShortListing } = props;

  if (isShortListing) {
    return (
      <div className={styles['container-short-listing']}>
        <div className={styles['pub-date-container']}>
          <PublicationDateContainer />
        </div>
        {isAgentUser && (
          <div className={styles['vas']}>
            <VASListContainer />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={styles['container']} onClick={stopPropagation}>
      <PublicationDateContainer />
      {isAgentUser && <VASListContainer />}
    </div>
  );
};
